import { Injectable } from '@angular/core';

import { Consorcio } from '../model/Consorcio';
import { Sucursal } from '../model/sucursal';


import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service'


@Injectable()
export class SucursalService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }


  getSucursales(consorcio: Consorcio): Observable<Sucursal[]> {

    let json = { "Metodo": "findSucursal", "Datos": consorcio };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }


  getSucursalesUsuario(query: any): Observable<Sucursal[]> {

    let json = { "Metodo": "getSucursalesUsuario", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

  

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  public insert(sucursal: Sucursal) {

    let json = { "Metodo": "postSucursal", "Datos": sucursal };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

  public delete(sucursal: Sucursal) {

    let json = { "Metodo": "deleteSucursal", "Datos": sucursal };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/sucursal.service.ts